interface Window {
  newrelic: { addPageAction: Function };
}

export function getWindow() {
  // @ts-expect-error returning window object
  return window as Window;
}
